module.factory('signupOrderDataService', function() {

  var orderData = {};

  var service = {
    save: save,
    get: get
  };

  return service;

  ///////////////////////

  function save(data) {
    orderData = data;
  }

  function get() {
    return orderData;
  }

});
